import React from 'react';
import { Logo } from './Logo';

class TempLoginComponent extends React.Component {
    public override render() {
        return (
            <div className="external-page external-alt">
                <div id="main" className="">
                    <section id="content">
                        <div className="admin-form theme-info" id="login">
                            <div className="row table-layout">
                                <Logo />
                            </div>

                            <div className="text-center fs16 fw600 mt40">
                                <p>The application is temporarily unavailable due to planned maintenance. </p>
                                <p>We apologize for the inconvenience caused.</p>
                                <p>Please try again later.</p>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        );
    }
}

export { TempLoginComponent };
